const LayoutDefault = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/layouts/LayoutDefault.vue'
  );
const LayoutData = () =>
  import(/* webpackChunkName: "admin-penjualan" */ '@/layouts/LayoutData.vue');
const Dashboard = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/dashboard/Index.vue'
  );
const TransaksiPenjualan = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/transaksi-penjualan/Index.vue'
  );
const TambahTransaksiPenjualan = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/transaksi-penjualan/TambahPenjualan.vue'
  );
const FakturSC = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/faktur-sc/Index.vue'
  );
const TambahFakturSC = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/faktur-sc/Tambah.vue'
  );
const RestockPbs = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/restock-pbs/Index.vue'
  );
const Laporan = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/laporan/Index.vue'
  );
const LaporanPenjualanKP = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/validasi/laporan-penjualan-kp/Index.vue'
  );
const LaporanPenjualanSC = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/validasi/laporan-penjualan-sc/Index.vue'
  );
const LaporanPenjualanPbs = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/laporan-penjualan-pbs/Index.vue'
  );

const LaporanPenjualanHarian = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/laporan/LaporanPenjualanHarian.vue'
  );
const LaporanJumlahBarang = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/laporan/LaporanJumlahBarang.vue'
  );

const ReturStockist = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/stockist/Index.vue'
  );

const TambahReturStockist = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/stockist/Tambah.vue'
  );
const ReturSC = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/stockist-center/Index.vue'
  );

const TambahReturSC = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/stockist-center/Tambah.vue'
  );
const ReturKP = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/pelayanan/Index.vue'
  );

const TambahReturKP = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/pelayanan/Tambah.vue'
  );
const ReturSupplier = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/supplier/Index.vue'
  );

const TambahReturSupplier = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/retur/supplier/Tambah.vue'
  );

const ValidasiSaldoReturStockist = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/validasi-saldo-retur/stockist/Index.vue'
  );

const SetPriceReturStockist = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/validasi-saldo-retur/stockist/SetPrice.vue'
  );

const ValidasiSaldoReturStockistCenter = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/validasi-saldo-retur/stockist-center/Index.vue'
  );

const SetPriceReturStockistCenter = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/validasi-saldo-retur/stockist-center/SetPrice.vue'
  );
const TopupDepositSc = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/topup/deposit-sc/Index.vue'
  );
const TambahTopupDepositSc = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/topup/deposit-sc/Tambah.vue'
  );
const CekFaktur = () =>
  import(
    /* webpackChunkName: "admin" */ '@/views/CekFaktur.vue'
  );
const KirimPromo = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/kirim-promo/Index.vue'
  );
const TambahKirimPromo = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/kirim-promo/Tambah.vue'
  );
const KirimBarangPromoKeSc = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/kirim-barang-promo/barang-ke-sc/Index.vue'
  );
const TambahKirimBarangPromoKeSc = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/kirim-barang-promo/barang-ke-sc/Tambah.vue'
  );
const KirimBarangPromoKeStockist = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/kirim-barang-promo/barang-ke-stockist/Index.vue'
  );
const TambahKirimBarangPromoKeStockist = () =>
  import(
    /* webpackChunkName: "admin-penjualan" */ '@/views/pusat/penjualan/kirim-barang-promo/barang-ke-stockist/Tambah.vue'
  );

let root = '/penjualan';

export default [
  {
    path: root + '/',
    component: Dashboard,
    meta: {
      auth: true,
      title: 'Dashboard | Penjualan Pusat',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/cek-faktur',
    component: CekFaktur,
    meta: {
      auth: true,
      title: 'Cek Faktur',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/kirim-promo/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Kirim Promo',
    },
    children: [
      {
        path: 'reimburse',
        component: KirimPromo,
        name: 'penjualan.kirim-promo',
        meta: {
          auth: true,
          title: 'Kirim Stok Promo dari Stok Reimburse SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Promo',
        },
      },
      {
        path: 'reimburse/tambah',
        component: TambahKirimPromo,
        name: 'penjualan.kirim-promo.tambah',
        meta: {
          auth: true,
          title: 'Kirim Stok Promo dari Stok Reimburse SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Stok Reimburse SC',
        },
      },
      {
        path: 'tambahan-sc',
        component: KirimBarangPromoKeSc,
        name: 'penjualan.kirim-barang-promo.ke-sc',
        meta: {
          auth: true,
          title: 'Tambahan Barang Promo di Luar Promo ke SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Promo',
        },
      },
      {
        path: 'tambahan-sc/tambah',
        component: TambahKirimBarangPromoKeSc,
        name: 'penjualan.kirim-barang-promo.ke-sc.tambah',
        meta: {
          auth: true,
          title: 'Kirim Tambahan Barang Promo ke SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Tambahan Barang Promo ke SC',
        },
      },
      {
        path: 'tambahan-stockist',
        component: KirimBarangPromoKeStockist,
        name: 'penjualan.kirim-barang-promo.ke-stockist',
        meta: {
          auth: true,
          title: 'Tambahan Barang Promo di Luar Promo ke Stockist | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Promo',
        },
      },
      {
        path: 'tambahan-stockist/tambah',
        component: TambahKirimBarangPromoKeStockist,
        name: 'penjualan.kirim-barang-promo.ke-stockist.tambah',
        meta: {
          auth: true,
          title: 'Kirim Tambahan Barang Promo ke Stockist | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Tambahan Barang Promo ke Stockist',
        },
      },
    ]
  },
  {
    path: root + '/laporan',
    component: LayoutData,
    meta: {
      breadcrumb: 'Laporan',
    },
    children: [
      {
        path: '',
        component: Laporan,
        meta: {
          auth: true,
          title: 'Laporan | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Laporan Penjualan',
        },
      },
      {
        path: 'harian/',
        component: LaporanPenjualanHarian,
        meta: {
          auth: true,
          title: 'Laporan Penjualan Harian | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Laporan Penjualan Harian',
        },
      },
      {
        path: 'jumlah-barang/',
        component: LaporanJumlahBarang,
        meta: {
          auth: true,
          title: 'Laporan Jumlah Penjualan Barang | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Laporan Jumlah Penjualan Barang',
        },
      },
    ],
  },
  {
    path: root + '/transaksi-penjualan/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Transaksi Penjualan',
    },
    children: [
      {
        path: '',
        component: TransaksiPenjualan,
        name: 'penjualan',
        meta: {
          auth: true,
          title: 'Transaksi Penjualan | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-transaksi-penjualan',
        name: 'penjualan.tambah',
        component: TambahTransaksiPenjualan,
        meta: {
          auth: true,
          title: 'Tambah Transaksi Penjualan | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Transaksi Penjualan',
        },
      },
      {
        path: ':id',
        component: TambahTransaksiPenjualan,
        name: 'penjualan.edit',
        meta: {
          auth: true,
          title: 'Edit Transaksi Penjualan | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
    ]
  },
  {
    path: root + '/retur/stockist',
    component: LayoutData,
    meta: {
      breadcrumb: 'Retur Penjualan',
    },
    children: [
      {
        path: '',
        component: ReturStockist,
        name: 'retur.stockist',
        meta: {
          auth: true,
          title: 'Retur Penjualan ke Stockist | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-retur',
        component: TambahReturStockist,
        name: 'create.retur.stockist',
        meta: {
          auth: true,
          title: 'Tambah Retur Penjualan ke Stockist | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Retur Penjualan',
        },
      },
      {
        path: 'tambah-retur/:id',
        component: TambahReturStockist,
        name: 'retur.stockist.edit',
        meta: {
          auth: true,
          title: 'Edit Retur Penjualan ke Stockist | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
    ],
  },
  {
    path: root + '/retur/stockist-center',
    component: LayoutData,
    meta: {
      breadcrumb: 'Retur Penjualan',
    },
    children: [
      {
        path: '',
        component: ReturSC,
        name: 'retur.stockist-center',
        meta: {
          auth: true,
          title: 'Retur Penjualan ke Stockist Center | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-retur',
        component: TambahReturSC,
        name: 'create.retur.stockist-center',
        meta: {
          auth: true,
          title: 'Tambah Retur Penjualan ke Stockist Center | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Retur Penjualan',
        },
      },
      {
        path: 'tambah-retur/:id',
        component: TambahReturSC,
        name: 'retur.stockist-center.edit',
        meta: {
          auth: true,
          title: 'Edit Retur Penjualan ke Stockist Center | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
    ],
  },
  {
    path: root + '/retur/kantor-pelayanan',
    component: LayoutData,
    meta: {
      breadcrumb: 'Retur Penjualan',
    },
    children: [
      {
        path: '',
        component: ReturKP,
        name: 'index.retur.pelayanan',
        meta: {
          auth: true,
          title: 'Retur Penjualan ke Kantor Pelayanan | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-retur',
        component: TambahReturKP,
        name: 'create.retur.pelayanan',
        meta: {
          auth: true,
          title: 'Tambah Retur Penjualan ke Kantor Pelayanan | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Retur Penjualan',
        },
      },
      {
        path: 'tambah-retur/:id',
        component: TambahReturKP,
        name: 'edit.retur.pelayanan',
        meta: {
          auth: true,
          title: 'Edit Retur Penjualan ke Kantor Pelayanan | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
    ],
  },
  {
    path: root + '/retur/supplier',
    component: LayoutData,
    meta: {
      breadcrumb: 'Retur Penjualan',
    },
    children: [
      {
        path: '',
        component: ReturSupplier,
        name: 'index.retur.supplier',
        meta: {
          auth: true,
          title: 'Retur Penjualan ke Supplier | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-retur',
        component: TambahReturSupplier,
        name: 'create.retur.supplier',
        meta: {
          auth: true,
          title: 'Tambah Retur Penjualan ke Supplier | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Retur Penjualan',
        },
      },
      {
        path: 'tambah-retur/:id',
        component: TambahReturSupplier,
        name: 'edit.retur.supplier',
        meta: {
          auth: true,
          title: 'Edit Retur Penjualan ke Supplier | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
    ],
  },
  {
    path: root + '/validasi/',
    component: LayoutData,
    children: [
      {
        path: 'laporan-penjualan-kp',
        component: LaporanPenjualanKP,
        meta: {
          auth: true,
          title: 'Laporan Penjualan KP | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Validasi Laporan Penjualan KP',
        },
      },
      {
        path: 'laporan-penjualan-sc',
        component: LaporanPenjualanSC,
        meta: {
          auth: true,
          title: 'Laporan Penjualan SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Validasi Laporan Penjualan SC',
        },
      },
    ],
  },
  {
    path: root + '/laporan-penjualan-pbs',
    component: LaporanPenjualanPbs,
    meta: {
      auth: true,
      title: 'Laporan Penjualan P3S | Penjualan Pusat',
      layout: LayoutDefault,
      breadcrumb: 'Validasi Laporan Penjualan KP',
    },
  },
  {
    path: root + '/faktur-sc/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Restock SC',
    },
    children: [
      {
        path: '',
        component: FakturSC,
        name: 'restock-sc',
        meta: {
          auth: true,
          title: 'Restock SC | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah',
        component: TambahFakturSC,
        name: 'restock-sc.tambah',
        meta: {
          auth: true,
          title: 'Tambah Restock SC | Gudang',
          layout: LayoutDefault,
          breadcrumb: 'Restock SC',
        },
      },
      {
        path: ':id',
        component: TambahFakturSC,
        name: 'restock-sc.edit',
        meta: {
          auth: true,
          title: 'Tambah Restock SC | Gudang',
          layout: LayoutDefault,
          breadcrumb: 'Restock SC',
        },
      },
    ],
  },
  {
    path: root + '/restock-pbs/',
    component: RestockPbs,
    meta: {
      auth: true,
      title: 'Restock P3S | Penjualan Pusat',
      layout: LayoutDefault,
      breadcrumb: 'Restock P3S',
    }
  },
  {
    path: root + '/validasi-saldo-retur/',
    component: LayoutData,
    children: [
      {
        path: 'retur-dari-stockist/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Validasi Saldo Retur',
        },
        children: [
          {
            path: '',
            name: 'validasi-saldo-retur.retur-dari-stockist',
            component: ValidasiSaldoReturStockist,
            meta: {
              auth: true,
              title: 'Validasi Saldo Retur dari Stockist | Penjualan',
              layout: LayoutDefault,
            },
            props: {
              title: 'Validasi Saldo Retur dari Stockist',
            },
          },
          {
            path: ':id',
            name: 'validasi-saldo-retur.retur-dari-stockist.set-price',
            component: SetPriceReturStockist,
            meta: {
              auth: true,
              title: 'Validasi Saldo Retur dari Stockist | Penjualan',
              layout: LayoutDefault,
              breadcrumb: 'Validasi Saldo Retur dari Stockist',
            },
          },
        ],
      },
      {
        path: 'retur-dari-stockist-center/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Validasi Saldo Retur',
        },
        children: [
          {
            path: '',
            name: 'validasi-saldo-retur.retur-dari-stockist-center',
            component: ValidasiSaldoReturStockistCenter,
            meta: {
              auth: true,
              title: 'Validasi Saldo Retur dari Stockist Center | Penjualan',
              layout: LayoutDefault,
            },
            props: {
              title: 'Validasi Saldo Retur dari Stockist Center',
            },
          },
          {
            path: ':id',
            name: 'validasi-saldo-retur.retur-dari-stockist-center.set-price',
            component: SetPriceReturStockistCenter,
            meta: {
              auth: true,
              title: 'Validasi Saldo Retur dari Stockist Center | Penjualan',
              layout: LayoutDefault,
              breadcrumb: 'Validasi Saldo Retur dari Stockist Center',
            },
          },
        ],
      },
    ],
  },
  {
    path: root + '/topup/deposit-sc/',
    component: LayoutData,
    children: [
      {
        path: '',
        component: TopupDepositSc,
        name: 'penjualan.topup.deposit-sc',
        meta: {
          auth: true,
          title: 'Topup Saldo Deposit SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Topup Saldo Saldo Deposit SC',
        },
      },
      {
        path: 'tambah',
        component: TambahTopupDepositSc,
        name: 'penjualan.topup.deposit-sc.tambah',
        meta: {
          auth: true,
          title: 'Tambah Topup Saldo Deposit SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Topup Saldo Deposit SC',
        },
      },
      {
        path: ':id',
        component: TambahTopupDepositSc,
        name: 'penjualan.topup.deposit-sc.edit',
        meta: {
          auth: true,
          title: 'Edit Topup Saldo Deposit SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Edit Topup Saldo Deposit SC',
        },
      },
    ],
  },
];
